export const copyToClipboard = async (value: string) => {
  try {
    // doesn't work in some browsers and without https
    if (typeof document === 'undefined' || typeof navigator === 'undefined') {
      return
    }

    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(value)
    } else {
      const textarea = document.createElement('textarea')
      textarea.value = value
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    }
  } catch (err) {
    console.error('Failed to copy: ', err)
  }
}
